export default __webpack_public_path__ + "static/media/element_8.6ca95ebc.webp";